"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => {
  var _theme$palette;
  return {
    svgWrapper: {
      display: "flex",
      justifyContent: "center",
      "& svg": {
        display: "block",
        maxWidth: 260,
        width: "100%"
      }
    },
    pathDefault: {
      fill: "inherit"
    },
    pathHighlight: {
      fill: theme === null || theme === void 0 || (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main
    },
    headline: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(5, 0, 3),
      textAlign: "center"
    },
    text: {
      margin: theme === null || theme === void 0 ? void 0 : theme.spacing(4, 0),
      textAlign: "center"
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "center"
    }
  };
});
var _default = exports.default = styles;